import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="owner-rez"
export default class extends Controller {
  static targets = [
    'ownerRezLink',
    'createNodesUsing',
    'customNodeField',
    'extraField'
  ]

  connect() {
    console.log('OwnerRezController connected');
  }

  redirectToOwnerRez(event) {
    event.preventDefault();

    if (!this.hasOwnerRezLinkTarget) return;

    const baseUrl = this.ownerRezLinkTarget.dataset.baseUrl;
    const companyId = this.ownerRezLinkTarget.dataset.companyId;

    const statePayload = {
      company_id: companyId
    };

    if (this.hasCreateNodesUsingTarget) {
      statePayload.create_nodes_using = this.createNodesUsingTarget.value;
    }

    if (this.hasCustomNodeFieldTarget) {
      statePayload.custom_node_field = this.customNodeFieldTarget.value;
    }

    if (this.hasExtraFieldTarget) {
      statePayload.custom_node_field_array_contains = this.extraFieldTarget.value;
    }

    const jsonString = JSON.stringify(statePayload);
    const encodedState = encodeURIComponent(btoa(jsonString));

    const finalUrl = `${baseUrl}&state=${encodedState}`;

    window.location.href = finalUrl;
  }
}
